module.exports = __webpack_public_path__ + "static/media/koryu_00003intro.57cf5f2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/koryu_00003intro.png
// module id = 217
// module chunks = 0